<template>
	<div class="home">
		<navbar :isHiddenlogin="true"></navbar>
		<div class="banner">
			<div class="banner-title">中国招标投标公共服务平台<br>培训证书查询</div>
		</div>
		<div class="main">
			<div class="tips" v-if="tip">
				<span>*</span>本页面信息来源于中国招标投标公共服务平台，证书信息查询一律免费，查询结果仅供参考。
			</div>
			<div class="search-waper">
				<div class="search">
					<div class="name">
						<div class="el-input el-input-group el-input-group--prepend">
							<div class="el-input-group__prepend">姓名</div><input type="text" v-model="ruleForm.name"
								autocomplete="off" placeholder="请输入姓名" class="el-input__inner">
						</div>
					</div>
					<div class="id">
						<div class="el-input el-input-group el-input-group--prepend">
							<div class="el-input-group__prepend">身份证号</div><input maxlength="18"
								v-model="ruleForm.idNumber" type="text" autocomplete="off" placeholder="请输入身份证号码"
								class="el-input__inner">
						</div>
					</div>
					<div class="search-item">
						<div class="search-btn" @click="getDatalist()">查询</div>
					</div>
				</div>
				<div class="container" v-loading="loading" v-show="list.length">
					<div class="state">查询结果</div>
					<el-table :header-cell-style="{ background: '#FAFAFA', color: '#606266', 'text-align': 'left' }"
						:data="list" style="width: 100%" stripe>
						<el-table-column align="left" type="index" label="序号" width="80px">
						</el-table-column>
						<el-table-column prop="userName" align="left" label="姓名" width="120px">
						</el-table-column>
						<el-table-column align="left" label="身份证号" prop="idCardNumber" width="240px">
						</el-table-column>
						<el-table-column prop="courseFullName" align="left" label="证书类型">
						</el-table-column>
						<el-table-column prop="certificateIssueTime" align="left" label="颁证日期" width="150px">
						</el-table-column>
						<el-table-column prop="certificatePublicUrl" align="left" label="查看" width="100px">
							<template slot-scope="scope">
								<span @click="cellclick(scope.row)" style="cursor: pointer;color: #4d85ff;">
									预览
								</span>
							</template>
						</el-table-column>
					</el-table>
					<!-- <div class="pagination">
						<div class="analysis">
							<span class="text">共</span>
							<span class="count">{{ list.total }}</span>
							<span class="text">条数据，第</span>
							<span class="count">{{ list.current }}/{{ list.pages }}</span>
							<span class="text">页。</span>
						</div>
						<el-pagination layout="prev, pager, next, sizes" v-bind:current-page="list.current"
							v-bind:page-size="list.size" v-bind:page-count="list.pages" v-bind:total="list.total"
							v-bind:page-sizes="[10, 20, 30, 50, 100]" v-bind:small="true" v-bind:background="true"
							v-bind:hide-on-single-page="false" @size-change="handleSizeChange"
							v-on:current-change="handle_pager_current_change"></el-pagination>
					</div> -->
				</div>
				<div class="noData" v-if="isData">暂无相关数据</div>
			</div>
			<footer-page></footer-page>
		</div>
		<div class="fixed-products-content-right-btn">
			<div class="fixed-products-content-ph">
				<p>培训业务咨询：</p>
				<p>010-88484118-826/862/822</p>
			</div>
		</div>
	</div>
</template>
<script>
import FooterPage from '@/components/footer.vue'
import navbar from '@/components/nav.vue'
import { getList } from '@/api/api.js'
import $ from 'jquery'
export default {
	name: "index",
	components: {
		navbar,
		FooterPage
	},
	data() {
		return {
			loading: false,
			input: '',
			list: [],
			tip: true,
			current: 1,
			size: 10,
			ruleForm: {
				name: "",
				idNumber: "",
			},
			isMenu: true,
			isData: false,
		}
	},
	computed: {

	},
	methods: {
		openMenu() {
			this.isMenu = !this.isMenu
		},
		// 加密文本
		formatName(name) {
			console.log(name)
			let newStr = "";
			if (name.length === 1) {
				let char = "";
				for (let i = 0, len = name.length; i < len; i++) {
					char += "*";
				}
				newStr = char;
			} else if (name.length === 2) {
				newStr = name.substr(0, 1) + "*";
			} else if (name.length === 3) {
				newStr = name.substr(0, 1) + "**";
			} else {
				newStr = name.substr(0, 2) + "**";
			}
			return newStr;
		},
		getDatalist() {
			this.loading = true
			if (this.ruleForm.name && this.ruleForm.idNumber) {
				let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				// if (!reg.test(this.ruleForm.idNumber)) {
				// 	this.$message.error('身份证输入不合法');
				// 	return false;
				// } else {
				var params = `userName=${this.ruleForm.name}&idCardNumber=${this.ruleForm.idNumber}`
				getList(params).then(response => {
					console.log(response)
					if (response.code == 200) {
						if (response.data.length) {
							if (response.data.length) {
								var data = [];
								this.isData = false
								for (let i = 0; i < response.data.length; i++) {
									data.push({
										key: i, //序号
										id: response.data[i].id,
										certificatePublicUrl: response.data[i].certificatePublicUrl,
										userName: this.formatName(response.data[i].userName),
										idCardNumber: response.data[i].idCardNumber,
										courseFullName: response.data[i].courseFullName,
										certificateIssueTime: response.data[i].certificateIssueTime
									});
								}
							}
							this.list = data
							// this.list = response.data
							this.loading = false
						} else {
							var data = [];
							this.list = [];
							this.loading = false
							this.isData = true
							// this.$message.error('暂无证书信息');
						}

					} else {
						this.$message.error('查询失败');
					}
				})
				// }
			} else {
				this.list = []
				this.loading = false
				this.$message.error('请填写完整信息');
			}
		},
		cellclick(row) {
			// var baseUrl=this.$UrlEncode.encode(row.certificatePublicUrl)
			let routeData = this.$router.resolve({ path: '/detail', query: { id: row.id } });
			window.open(routeData.href, '_blank');
		},
		handleSizeChange(val) {
			this.size = val
			this.getDatalist();
		},
		handle_pager_current_change(val) {
			this.current = val
			this.getDatalist();
		}
	},
	mounted() {
		this.isData = false
	}
}
$.fn.menu = function (b) {
	var c,
		item,
		httpAdress;
	b = jQuery.extend({
		Speed: 220,
		autostart: 1,
		autohide: 1
	},
		b);
	c = $(this);
	item = c.children("ul").parent("li").children("a");
	httpAdress = window.location;
	item.addClass("inactive");

	function _item() {
		var a = $(this);
		if (b.autohide) {
			a.parent().parent().find(".active").parent("li").children("ul").slideUp(b.Speed / 1.2,
				function () {
					$(this).parent("li").children("a").removeAttr("class");
					$(this).parent("li").children("a").attr("class", "inactive")
				})
		}
		if (a.attr("class") == "inactive") {
			a.parent("li").children("ul").slideDown(b.Speed,
				function () {
					a.removeAttr("class");
					a.addClass("active")
				})
		}
		if (a.attr("class") == "active") {
			a.removeAttr("class");
			a.addClass("inactive");
			a.parent("li").children("ul").slideUp(b.Speed)
		}
	}
	item.unbind('click').click(_item);
	if (b.autostart) {
		c.children("a").each(function () {
			if (this.href == httpAdress) {
				$(this).parent("li").parent("ul").slideDown(b.Speed,
					function () {
						$(this).parent("li").children(".inactive").removeAttr("class");
						$(this).parent("li").children("a").addClass("active")
					})
			}
		})
	}
}
</script>
<style scoped>
.link {
	color: #409EFF;
	cursor: pointer;
}

.main {
	width: 942px;
	margin: 0 auto;
	padding-left: 35px;
}

.banner {
	background-image: url('@/assets/banner.png');
	background-size: 100% 100%;
	height: 380px;
	display: flex;
}

.banner-title {
	font-size: 48px;
	text-align: center;
	color: #FFFFFF;
	font-weight: bold;
	letter-spacing: 6px;
	align-self: center;
	margin: 0 auto;
}

.banner-a {
	width: 500px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 70px;
}

.banner-a a {
	color: #fff;
	font-size: 25px;
	font-style: normal;
	text-decoration: none;
	font-weight: bold;
}

.search-waper {
	margin: 65px 0;
}

.search-waper .search input::placeholder {
	color: #acabab;

}

.el-input-group__append,
.el-input-group__prepend {
	border: 1px solid #acabab;
	color: #000;
}

.el-input__inner {
	border: 1px solid #acabab;
	border-left: none;
	font-family: monospace;
}

.search {
	color: #333333;
	font-size: 14px;
	width: 942px;
	margin: 0 auto;
	height: 40px;
}

.name,
.id {
	width: 330px;
	display: inline-block;
	float: left;
	margin-right: 85px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
}

input[type='number'] {
	-moz-appearance: textfield;
}

.search-item {
	line-height: 40px;
}

.search-item .el-input {
	width: 200px;
	height: 35px;
}

.search-item .el-input>>>.el-input__inner {
	height: 35px;
}

.search-btn {
	width: 110px;
	height: 40px;
	text-align: center;
	line-height: 40px;
	color: #fff;
	background-color: rgba(0, 68, 231, 1);
	border-radius: 3px;
	cursor: pointer;
	float: left;
}

.container {
	margin-top: 35px;
}

.el-form-item {
	margin-bottom: 0;
}

.el-table /deep/ .el-table__header-wrapper th {
	background-color: #eaeaea;
	padding: 5px 0;
	font-weight: normal;
	color: #000;
	line-height: 39px;
	height: 39px;
}

.container /deep/ .pagination .el-pagination .el-pagination__sizes .el-select .el-input .el-input__inner {
	height: 24px;
	line-height: 24px;
}

.search .search-item /deep/ .el-input .el-input__inner {
	height: 28px;
	line-height: 28px;
}

.pagination {
	padding: 1rem 0 2rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.analysis {
	font-size: 12px;
	color: #909399;
}

.bottom {
	text-align: center;
}

.footer {
	text-align: center;
	font-size: 13px;
}

.copyright_info {
	background-color: #888787;
	color: #cccccc;
	padding: 11px 0;
}

.copyright_auth {
	background-color: rgba(0, 68, 231, 1);
	color: #fff;
	padding: 27px 0 27px;
}

.tips {
	background: rgba(251, 248, 229, 1);
	line-height: 45px;
	position: relative;
	width: 942px;
	margin: 0 auto;
	font-size: 15px;
	text-align: left;
	font-family: SourceHanSansSC-regular;
	margin-top: 20px;
	height: 45px;
	text-align: center;
	font-size: 18px;
}

.tips span {
	color: red;
	margin-right: 5px;
}

.close {
	width: 40px;
	height: 40px;
	position: absolute;
	right: 0;
	background-size: 30px 30px;
	top: 0;
	background-image: url(~@/assets/close.png);
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
}

.el-input-group__append,
.el-input-group__prepend {
	padding: 0 12px;
	background: #fff;
}

.state {
	line-height: 40px;
	font-weight: bold;
	font-size: 18px;
	color: #000;
	border-bottom: 1px solid #ccc;
	margin-bottom: 20px;
}

.el-table {
	font-size: 14px;
	text-align: left;
}

.fixed-products-content-right-btn {
	position: fixed;
	right: -20px;
	top: 465px;
	z-index: 999;
	opacity: 1;
	background: #fff;
	box-shadow: 0px 0px 15px -8px rgb(0 0 0 / 50%);
	color: #000;
	height: 47.5px;
	width: 275px;
	margin: 0 auto;
	border-radius: 50px;
	margin-top: 36px;
	font-size: 14px;
	text-indent: 55px;
	padding-top: 7.5px;
}

.fixed-products-content-ph {
	background-image: url(~@/assets/tel.png);
	background-repeat: no-repeat;
	background-position: 20px center;
	background-size: 26px;
}

.fixed-products-content-right-btn p {
	height: 20px;
	margin: 0;
}


.fixedTip {
	position: fixed;
	height: 100px;
	padding: 15px 0px;
	width: 170px;
	z-index: 999;
	top: 50%;
	left: 0%;
	margin-top: -50px;
	margin-left: 0;
}

.noData {
	width: 1000px;
	margin: 0 auto;
	text-align: center;
	line-height: 50px;
	margin-top: 50px;
	color: #F56C6C;
}

#footer {
	width: 1000px;
	margin: 0px auto;
	padding-bottom: 50px;
}
</style>